import { Component } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { environment } from '@env/environment';
import { HttpUtilService } from '@services/http-util.service';
import { NotificationsService } from '@services/notifications.service';
import { ConfirmDialog } from '@generic/confirm-dialog/confirm-dialog.component';
import { ScaffoldDialogService } from '@app/framework/dialog/scaffold-dialog.service';
import { TranslationService } from '@services/translation.service';
interface Settings {
  source?: string;
  type?: string;
}
@Component({
    selector: 'app-data-config-update',
    templateUrl: './data-config-update.component.html',
    styleUrls: ['./data-config-update.component.scss'],
    standalone: false
})
export class DataConfigUpdateComponent {
  constructor(
    private translationService: TranslationService,
    private dataModelService: DataModelService,
    private http: HttpUtilService,
    private notifications: NotificationsService,
    private dialog: ScaffoldDialogService
  ) {}
  envList = ['test', 'production', 'default'];
  productsList = [
    { text: 'Archiving', value: 'archiving' },
    { text: 'Canvas Archiving', value: 'archivingv2' },
    { text: 'AI Detection', value: 'ai-detection' },
    { text: 'Designer', value: 'designer' },
    { text: 'Default', value: '' },
  ];
  /** The source environment for the config */
  source: string;
  /** The config type to overide the default for the instance*/
  type: string;
  /**
   * Update the configuration
   *
   * @memberof DataModelPrefsComponent
   * @returns {void}
   */
  updateConfiguration(): void {
    const settings: Settings = {};
    if (this.source?.length > 0) {
      settings.source = this.source;
    }
    if (this.type?.length > 0) {
      settings.type = this.type;
    }

    const dialogRef = this.dialog.open(ConfirmDialog, {
      context: {
        data: {
          title: 'Confirm Action',
          message:
            'Are you sure you want to overwrite this configuration? This action cannot be undone.',
        },
      },
    });

    dialogRef.onClose.subscribe(confirm => {
      if (confirm) {
        this.http
          .request(
            'PUT',
            environment.apiRoot + '/configupdate',
            settings,
            null,
            true
          )
          .subscribe(
            response => {
              this.notifications.popNotification(
                '',
                this.translationService.getTranslatedContent(
                  'the_configuration_has_been_updated',
                  'The configuration has been updated'
                )
              );
            },
            error => {
              this.notifications.popNotification(
                '',
                this.translationService.getTranslatedContent(
                  'the_configuration_could_not_be_updated',
                  'The configuration could not be updated'
                )
              );
            }
          );
      }
    });
  }
}
